import { useSyncExternalStore } from 'react';

// On-screen keyboard height (Flutter MediaQuery.viewInsets.bottom), derived from
// the visual viewport. While subscribed it is also published as the CSS
// variable `--keyboard-inset` on <html>.

let inset = 0;
const listeners = new Set<() => void>();

function measure(): number {
  const vv = typeof window !== 'undefined' ? window.visualViewport : null;
  if (!vv) return 0;
  return Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
}

function update(): void {
  const next = measure();
  if (next === inset) return;
  inset = next;
  document.documentElement.style.setProperty('--keyboard-inset', `${inset}px`);
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  const vv = typeof window !== 'undefined' ? window.visualViewport : null;
  if (listeners.size === 0 && vv) {
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    update();
  }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && vv) {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    }
  };
}

/** Current keyboard inset in px (0 when the keyboard is closed or unsupported). */
export function useKeyboardInset(): number {
  return useSyncExternalStore(subscribe, () => inset, () => 0);
}
